import CloseIcon from "@mui/icons-material/Close";
import {
  DialogActions,
  DialogContent,
  Dialog as MuiDialog,
  DialogTitle,
  IconButton,
  styled
} from "@mui/material";
import React from "react";
import { HyroButton } from "@hyro-components";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "@hyro-components/hyro-button/HyroButton.consts";

const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  paddingRight: theme.spacing(3),
  paddingBottom: theme.spacing(3)
}));

const HyroDialog = ({
  variant = "passive",
  open,
  title,
  children,
  disableSave,
  disableCancel,
  submitButtonProps = {},
  submitButtonLoading = false,
  submitButtonText = "Confirm",
  cancelButtonText = "Cancel",
  cancelButtonLoading = false,
  handleCancel,
  handleSubmit,
  testId,
  handleClose,
  showCloseButton = false,
  showSaveButton = true,
  showCancelButton = true,
  ...props
}) => (
  <MuiDialog
    {...{
      fullWidth: true,
      open,
      ...props
    }}
    data-testid={testId}
  >
    <DialogTitle sx={{ padding: "18px 24px 12px 24px" }} component="h6" data-testid={`${testId}-dialog-title`}>{title}</DialogTitle>
    <DialogContent>{children}</DialogContent>
    {showCloseButton ? (
      <IconButton
        data-testid={`${testId}-close-icon`}
        onClick={handleClose}
        aria-label="close"
        sx={{ position: "absolute", right: 8, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
    ) : null}
    {variant === "acknowledgement" || variant === "transactional" ? (
      <StyledDialogActions>
        {variant === "transactional" && showCancelButton ? (
          <HyroButton
            disabled={disableCancel}
            loading={cancelButtonLoading}
            variant={BUTTON_VARIANTS.TEXT}
            color={BUTTON_COLORS.SECONDARY}
            onClick={handleCancel}
            data-testid={`${testId}-cancel-button`}
          >
            {cancelButtonText}
          </HyroButton>
        ) : null}
        {showSaveButton && <HyroButton
          {...{
            loading: submitButtonLoading,
            disabled: disableSave,
            color: BUTTON_COLORS.PRIMARY,
            variant: BUTTON_VARIANTS.CONTAINED,
            onClick: handleSubmit,
            ...submitButtonProps
          }}
          data-testid={`${testId}-submit-button`}
        >
          {submitButtonText}
        </HyroButton>}
      </StyledDialogActions>
    ) : null}
  </MuiDialog>
);

export default HyroDialog;
